import React, { PureComponent } from 'react';
import $ from 'jquery';
import * as topojson from 'topojson';
import * as TurfHelpers from '@turf/helpers';

import MapCTA from '../MapCTA';
import Result from '../Result';
import MobileOverlay from '../MobileOverlay';
import Icon from '~/core/scripts/components/icon';
import Utils from '~/core/scripts/utils';

import Map from './map';
import './map.styl';

const stepClasses = {
  draw: 'step-1',
  result: 'step-2'
};

class MapWrapper extends PureComponent {

  state = {
    userScore: false,
    errorMessage: null,
    step: 'draw',
    tileType: '1989',
    mapMounted: false,
    drawCoords: [],
    serverCoords: [],
    isLoading: true,
    count: false
  }

  constructor() {
    super();

    this.berlinGeojson = null;
    this.westGeojson = null;
    this.eastGeojson = null;
    this.innerBorder = null;

    this.map = {};

    this.trackedDraw = false;
  }

  componentDidMount() {
    this.loadDataLayer();

    $('html').addClass('step-1');
  }

  componentDidUpdate() {
    $('html').removeClass('step-1');
    $('html').removeClass('step-2');
    $('html').removeClass('step-3');
    $('html').removeClass('has-result');

    $('html').addClass(stepClasses[this.state.step]);

    if (this.state.userScore) {
      $('html').addClass('has-result');
    }
  }

  onMapMounted = (leafletMap) => {
    this.map = leafletMap;
    this.setState({ mapMounted: true })
  }

  loadDataLayer() {
    $.when(
      $.getJSON('data/deu-clean.topo.json'),
      $.getJSON('data/west.topo.json'),
      $.getJSON('data/east.topo.json'),
      $.getJSON('data/border-clean.topo.json')
    ).done((berlinTopo, westTopo, eastTopo, innerBorder) => {
      const westGeojson = topojson.feature(westTopo[0], westTopo[0].objects[Object.keys(westTopo[0].objects)[0]]);
      const eastGeojson = topojson.feature(eastTopo[0], eastTopo[0].objects[Object.keys(eastTopo[0].objects)[0]]);

      this.berlinGeojson = topojson.feature(berlinTopo[0], berlinTopo[0].objects[Object.keys(berlinTopo[0].objects)[0]]);
      this.westGeojson = TurfHelpers.polygon(westGeojson.features[0].geometry.coordinates);
      this.eastGeojson = eastGeojson.features[0];
      this.innerBorder = topojson.feature(innerBorder[0], innerBorder[0].objects[Object.keys(innerBorder[0].objects)[0]]);

      this.setState({ isLoading: false });
    });
  }

  onDrawingFinished = (serverResp, userScore, drawCoords, serverCoords) => {
    this.setState({
      userScore,
      userScoreComp: serverResp.scoring.score,
      userRank: serverResp.scoring.rank,
      step: 'result',
      drawCoords,
      serverCoords: serverResp.borders,
      isLoading: false,
      count: serverResp.count
    });

    const sharerTop = $('.map__sharer').offset().top;
    if (sharerTop + 30 > window.scrollY + window.innerHeight) {
      $('body,html').animate({
        scrollTop: (sharerTop - window.innerHeight) + 55,
        duration: 600
      });
    }

    if (!this.trackedDraw) {
      Utils.trackEvent('draw', 1, 'class_A');
      this.trackedDraw = true;
    }
  }

  onDrawError = (errorMessage) => {
    this.setState({ errorMessage });
    Utils.trackEvent('draw_error', errorMessage);
  }

  onBackClick = () => {
    this.setState({
      step: 'result',
      tileType: '1989'
    });

    this.mapComp.goToResult();

    Utils.trackEvent('back');
  }

  onChangeTileType = (tileType) => {
    Utils.trackEvent('change_mode', tileType);

    return (evt) => {
      this.setState({ tileType });
    }
  }

  onDrawAgain = () => {
    this.setState({
      step: 'draw',
      serverCoords: [],
      drawCoords: [],
      userScore: false,
      errorMessage: null
    });

    Utils.trackEvent('draw_again');
  }

  onLoad = (isLoading = true) => {
    this.setState({ isLoading })
  }

  render() {
    return [
      <div className="map-comp-wrapper" key="mapwrapper">
        <MapCTA
          errorMessage={this.state.errorMessage}
          userScore={this.state.userScore}
        />
        <MobileOverlay
          map={this.map}
          mapMounted={this.state.mapMounted}
          step={this.state.step}
        />
        {this.state.isLoading && (
          <div className="map__loader">
            <Icon type="loading" className="spin" />
          </div>
        )}
        {this.berlinGeojson && <Map
          ref={ref => {this.mapComp = ref;}}
          shouldRender={this.berlinGeojson}
          config={this.props.config}
          berlinGeojson={this.berlinGeojson}
          westGeojson={this.westGeojson}
          eastGeojson={this.eastGeojson}
          innerBorder={this.innerBorder}
          onDrawingFinished={this.onDrawingFinished}
          userScore={this.state.userScore}
          onMapMounted={this.onMapMounted}
          onDrawError={this.onDrawError}
          step={this.state.step}
          tileType={this.state.tileType}
          drawCoords={this.state.drawCoords}
          serverCoords={this.state.serverCoords}
          onLoad={this.onLoad}
        />}
      </div>,
      <Result
        key="result"
        step={this.state.step}
        userScore={this.state.userScore}
        userRank={this.state.userRank}
        userScoreComp={this.state.userScoreComp}
        onDrawAgain={this.onDrawAgain}
        count={this.state.count}
      />
    ]
  }
}

export default MapWrapper;
